<template>
	<main class="practice-sheet-new-edit">
		<div class="practiceList" @click="ReturnSuperior">
			<div class="aigx">
				<i class="el-icon-arrow-left superior" style="font-size: 15px; font-weight: 1000;"></i>
				<span>&nbsp;&nbsp;返回</span>
			</div>
		</div>
		<div style="padding-left: 23px; padding-top: 23px;">
			<p>谱例同步文件：</p>
			<div v-if="infox?.abc_json_val != null" class="compliance-setting2" :style="{ pointerEvents: infox?.is_owner ? '' : 'none' }">
				<div class="photoItem" v-for="item in 1" :key="item" @click="editemusice(infoId)">
					<div class="phtosize">
						<img
							:initial-index="item - 1"
							loading="lazy"
							style="width: 70px; height: 60px; position: absolute; margin-left: 5px; margin-top: 11px;"
							fit="contain"
							:src="ErrorImgYik"
						/>
					</div>
					<div class="info">{{ infox?.name }}</div>
				</div>
			</div>
			<div v-else class="empty-data compliance-setting2" style="height: 120px; justify-content: space-around;" :style="{ pointerEvents: infox?.is_owner ? '' : 'none' }">
				<span style="width: 100%; padding-top: 40px;">暂无内容</span> <br />
				<el-link
					style="padding-bottom: 15px; color: #ff5e2a;"
					:underline="false"
					target="_blank"
					@click="NewScore"
					v-if="infox?.is_owner"
					>去曲谱制作>></el-link
				>
			</div>
			<p>谱音同步文件：</p>
			<div v-if="infox?.music.length !== null && infox?.music.length > 0" class="compliance-setting" :style="{ pointerEvents: infox?.is_owner ? '' : 'none' }">
				<div class="compliance-setting1">
					<div class="photoItem" v-for="item in infox?.music" :key="item" @click="SetScoreSync(infoId)">
						<div class="phtosize">
							<img
								:initial-index="item - 1"
								loading="lazy"
								style="width: 70px; height: 60px; position: absolute; margin-left: 5px; margin-top: 11px;"
								fit="contain"
								:src="ErrorImgYik"
							/>
						</div>
						<div class="info" v-if="item?.audio_type === '1'">音频</div>
						<div class="info" v-else-if="item?.audio_type === '2'">男高音</div>
						<div class="info" v-else-if="item?.audio_type === '3'">男中音</div>
						<div class="info" v-else-if="item?.audio_type === '4'">男低音</div>
						<div class="info" v-else-if="item?.audio_type === '5'">女高音</div>
						<div class="info" v-else-if="item?.audio_type === '6'">女中音</div>
						<div class="info" v-else-if="item?.audio_type === '7'">女低音</div>
						<div class="info" v-else-if="item?.audio_type === '8'">伴唱</div>
						<div class="info" v-else-if="item?.audio_type === '9'">范唱</div>
					</div>
				</div>
				<!-- <el-button type="primary" class="action-btnaAx" size="small">去谱音同步器</el-button> -->
			</div>
			<div v-else class="empty-data compliance-setting2" style="height: 120px; justify-content: space-around;" :style="{ pointerEvents: infox?.is_owner ? '' : 'none' }">
				<span style="width: 100%; padding-top: 40px;">暂无内容</span> <br />
				<el-link
					style="padding-bottom: 15px; color: #ff5e2a;"
					:underline="false"
					target="_blank"
					@click="SetScoreSync(infoId)"
					v-if="infox?.is_owner"
					>去谱音同步器制作>></el-link
				>
			</div>
      <!-- <p>跟唱同步文件：</p>
			<div v-if="outc > 0" class="compliance-setting2">
				<div class="photoItem" v-for="item in 2" :key="item">
					<div class="phtosize">
						<img
							:initial-index="item - 1"
							loading="lazy"
							style="width: 70px; height: 60px; position: absolute; margin-left: 5px; margin-top: 11px;"
							fit="contain"
							:src="ErrorImgYik"
						/>
					</div>
					<div class="info">男高音</div>
				</div>
			</div>
			<div v-else class="empty-data compliance-setting2" style="height: 120px; justify-content: space-around;">
				<span style="width: 100%; padding-top: 40px;">暂无内容</span> <br />
				<el-link v-if="infox?.is_owner" style="padding-bottom: 15px; color: #ff5e2a;" :underline="false" target="_blank" @click="erobug()"
					>去跟唱同步器制作>></el-link
				>
			</div> -->
			<p>谱例信息：</p>
			<div _m="l-20px" style="display: flex;">
				<span _flex="~ items-center">标题：</span>
				<el-input :disabled="true" :value="infox?.base_info.title" maxlength="20" style="flex: 1;"></el-input>
			</div>
			<div _m="l-20px" style="display: flex; margin-top: 15px;">
				<span _flex="~ items-center">作曲：</span>
				<el-input :disabled="true" :value="infox?.base_info.composer" maxlength="20" style="flex: 1;"></el-input>
			</div>
			<div _m="l-20px" style="display: flex; margin-top: 15px;">
				<span _flex="~ items-center">调号：</span>
				<el-input
					style="width: 747px; flex: 1;"
					:disabled="true"
					:value="infox?.base_info.keySign"
					maxlength="20"
				></el-input>

				<span _m="l-20px" _flex="~ items-center">拍号：</span>
				<el-input
					:disabled="true"
					:value="infox?.base_info.timeSign"
					maxlength="20"
					style="width: 984px; flex: 1;"
				></el-input>
			</div>
			<div _m="l-20px" style="display: flex; margin-top: 15px;">
				<span _flex="~ items-center">速度：</span>
				<el-input
					style="width: 747px; flex: 1;"
					:disabled="true"
					:value="infox?.base_info.speed"
					maxlength="20"
				></el-input>

				<span _m="l-20px" _flex="~ items-center">有转调：</span>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.isChangeKeySign == true"
					value="是"
					maxlength="20"
					style="width: 984px; flex: 1;"
				></el-input>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.isChangeKeySign == false"
					value="否"
					maxlength="20"
					style="width: 984px; flex: 1;"
				></el-input>
			</div>
			<div _m="l-20px" style="display: flex; margin-top: 15px;">
				<span _flex="~ items-center">有变化拍：</span>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.isChangeTimeSign == true"
					value="是"
					maxlength="20"
					style="width: 747px; flex: 1;"
				></el-input>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.isChangeTimeSign == false"
					value="否"
					maxlength="20"
					style="width: 747px; flex: 1;"
				></el-input>

				<span _m="l-20px" _flex="~ items-center">弱起小结：</span>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.isUpbeat == true"
					value="是"
					maxlength="20"
					style="width: 984px; flex: 1;"
				></el-input>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.isUpbeat == false"
					value="否"
					maxlength="20"
					style="width: 984px; flex: 1;"
				></el-input>
			</div>
			<div _m="l-20px" style="display: flex; margin-top: 15px;">
				<span _flex="~ items-center">谱表类型：</span>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.musicType == 'easy'"
					value="简谱"
					maxlength="20"
					style="width: 747px; flex: 1;"
				></el-input>
				<el-input
					:disabled="true"
					v-else-if="infox?.base_info.musicType == 'big'"
					value="大谱表"
					maxlength="20"
					style="width: 747px; flex: 1;"
				></el-input>
				<el-input
					:disabled="true"
					v-else-if="infox?.base_info.musicType == 'treble'"
					value="高音"
					maxlength="20"
					style="width: 747px; flex: 1;"
				></el-input>
				<el-input
					:disabled="true"
					v-else-if="infox?.base_info.musicType == 'bass'"
					value="低音"
					maxlength="20"
					style="width: 747px; flex: 1;"
				></el-input>
				<el-input
					:disabled="true"
					v-else-if="infox?.base_info.musicType == 'four'"
					value="合唱四声部"
					maxlength="20"
					style="width: 747px; flex: 1;"
				></el-input>

				<span _m="l-20px" _flex="~ items-center">谱有歌词：</span>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.isHasLyric == true"
					value="是"
					maxlength="20"
					style="width: 984px; flex: 1;"
				></el-input>
				<el-input
					:disabled="true"
					v-if="infox?.base_info.isHasLyric == false"
					value="否"
					maxlength="20"
					style="width: 984px; flex: 1;"
				></el-input>
			</div>
		</div>
	</main>
</template>
<script>
const ErrorImgYik = require('@/assets/test_client/Group.png')
export default {
	data() {
		return {
			ErrorImgYik,
			form_user: {},
			iosc: 0,
			axsc: 1,
			outc: 0,
			infox: {
				base_info: [null],
				music: [null]
			}, // 曲谱信息
			infoId: null,
			ptId: null
		}
	},
	mounted() {
		this.CheckCheck(this.$route.params.id, this.$route.params.ptid)
	},
	methods: {
		async CheckCheck(scoreid, id) {
			this.ptId = id
			this.infoId = scoreid
			let res = null
			res = await this.$api.bureau.GetBaseInfo(scoreid)
			this.infox = res
		},
		ReturnSuperior() {
			this.$router.go(-1)
		},

		//获取Token
		GetToken() {
			let loadConfigStr = localStorage.getItem('tokenInfo')
			let loadConfig = null
			if (loadConfigStr) {
				loadConfig = JSON.parse(loadConfigStr)
			}
			return loadConfig.access_token
		},
		//去设置谱音同步
		SetScoreSync(scoreid) {
			if (this.$store.state.user.userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value) {
				let accesstoken = this.GetToken()
				window.open(`${window.web_config.api_url}/music_score_audio?token=${accesstoken}&id=${scoreid}`)
			} else if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value && this.ptId != 0) {
				let accesstoken = this.GetToken()
				window.open(`${window.web_config.api_url}/music_score_audio?token=${accesstoken}&id=${scoreid}`)
			}
		},
		//修改谱例
		editemusice(scoreid) {
			if (this.$store.state.user.userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value) {
				let accesstoken = this.GetToken()
				window.open(`${window.web_config.api_url}/music_score_editor?token=${accesstoken}&id=${scoreid}`)
			} else if (this.$store.state.user.userInfo.type === this.$api.account.types.TEACHER.value && this.ptId != 0) {
				let accesstoken = this.GetToken()
				window.open(`${window.web_config.api_url}/music_score_editor?token=${accesstoken}&id=${scoreid}`)
			}
		},
		//去曲谱制作
		NewScore() {
			let accesstoken = this.GetToken()
			window.open(`${window.web_config.api_url}/music_score_editor?token=${accesstoken}`)
		},
		erobug() {
			this.$message({
				message: '该功能暂未开放，尽情期待',
				type: 'warning'
			})
		}
	}
}
</script>
<style lang="scss" scoped>
/deep/.practiceList {
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #3e3e3e;
	-webkit-background-clip: text;
}
/deep/.superior:hover {
	color: #ff5e2a;
}
/deep/.photoItem {
	margin: 1px;
	cursor: pointer;
}
.aigx {
	width: 70px;
	color: black;
}
.aigx:hover {
	cursor: pointer;
	color: #ff5e2a;
}
/deep/.phtosize {
	border: 1px solid #cfd7e7;
	border-radius: 6px 6px 6px 6px;
	width: 75px;
	height: 80px;
	margin-right: 20px;
}

.phtosize:first-of-type {
	margin-left: 10px;
}

.info {
	text-align: center;
	padding: 10px 0;
	color: #777777;
	border-radius: 3px 3px 3px 3px;
	opacity: 1;
	border: 1px solid #cfd7e7;
	width: 75px;
	height: 2px;
	margin-left: 10px;
	margin-top: 10px;
	margin-bottom: 10px;
	line-height: 2px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
} /*
.info:hover {
	width: auto;
	overflow: visible;
	white-space: normal;
	word-wrap: break-word;
} */
.action-btnaAx {
	width: 100px;
	height: 33px;
	text-align: center;
	padding-left: 11px;
	margin-left: 45px;
	margin-bottom: 5px;
}
.compliance-setting {
	padding: 5px 0;
	background-color: #f5f5f5cb;
	margin-right: 10%;
}
.practice-sheet-new-edit {
	background-color: #fff;
	padding-top: 10px;
	padding-left: 10px;
	padding-bottom: 15px;
	padding-right: 25%;
}
.practice-sheet-new-edit .compliance-setting {
	padding: 10px 0;
	border-radius: 5px;
}

.compliance-setting1 {
	display: flex;
	flex-wrap: wrap;
}
.el-dialog__body {
	padding: 15px 20px;
	color: #666666;
	font-size: 14px;
	word-break: break-all;
}
.practice-sheet-new-edit {
	.compliance-setting2 {
		display: flex;
		margin-right: 10%;
		flex-wrap: wrap;
		padding: 5px 0;
		padding-top: 8px;
		background-color: #f5f5f5cb;
	}
}
</style>
